module.exports = __webpack_public_path__ + "img/04.dd5e26f9.png";